const ITEMS = [
  "ITALIAN MARBLE POLISH",
  "GRANITE DIAMOND BUFFING",
  "SPECIAL HAIRLINE CRACK REPAIR",
  "CHEMICAL EPOXY COATING",
  "TILES MARBLE GRANITE FIXING",
  "ACID WASH & STAIN REMOVAL",
];

export default function Marquee() {
  return (
    <div className="bg-slate-900 text-white py-4 overflow-hidden border-y border-slate-800" aria-hidden="true">
      <div className="mq items-center gap-10 text-xs font-bold uppercase tracking-widest">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center gap-3">
            <span>✦</span> {item}
          </span>
        ))}
      </div>
    </div>
  );
}
